module.exports = __webpack_public_path__ + "img/D202402_2.a182fdad.jpg";